
// ********* Import CSS *************** //

import '@styles/main.scss';
import "./instructors.css";

// ********* Add Top Nav & Footer *************** //

import '../nav-header-footer/nav-header-footer.js';
import '../nav-header-footer/nav-header-footer.css';

// ************ Add JS for Email Signup & Error Popup *************** //

import '../nav-header-footer/email-contact-new-classes.js';

// **************************** Loading Spinner ****************************** //

window.addEventListener('load', () => {
  const preloader = document.getElementById("preloader");
  if (preloader) {
    preloader.style.display = "block";
    setTimeout(() => {
      preloader.style.transition = "opacity 0.2s ease";
      preloader.style.opacity = 0;
      setTimeout(() => preloader.remove(), 200);
    }, 1000);
  }
});

// **************************** JS - Headshot Images for the JSON-LD Schema ****************************** //


// const scriptTag = document.getElementById('schema-instructors');

// if (scriptTag) {

//   const schemaData = JSON.parse(scriptTag.text);


//   const elements = schemaData['@graph'][1].mainEntity.itemListElement;
  

//   const origin = window.location.origin;
  

//   scriptTag.text = JSON.stringify(schemaData);
// }

// **************************** JS - SubMenu Filter Buttons ****************************** //

document.addEventListener('DOMContentLoaded', () => {

	 const filterButtons = document.querySelectorAll('#filterButtonGroup button');

	 const cards = document.querySelectorAll('.instructor-card');

	 let currentFilter = 'current';

	 function applyFilters() {
		cards.forEach(card => {
		 	if (card.classList.contains(currentFilter)) {
		 		card.classList.remove('d-none');
		 	} else {
		 		card.classList.add('d-none');
		 	}
		});
	 }

 	// Initial execution to establish initial state

 	applyFilters();

	filterButtons.forEach(button => {
	 
	 	button.addEventListener('click', (event) => {

      console.log("Instructor button clicked");
	 
	 		filterButtons.forEach(btn => btn.classList.remove('active'));
	 
	 		event.target.classList.add('active');
	 
	 		currentFilter = event.target.getAttribute('data-filter');
	 
	 		applyFilters();
	 	});
	});
});